$(document).on('change','.new-custom-created-select', function(){
  var current_val = $(this).val();
  var price, com_price;
  $(this).find('option').each(function(){
    if(current_val == $(this).val()){
      price = $(this).data('price');
      com_price = $(this).data('com_price');
      if(com_price != '') {
        $(this).parents('.card_product_variant_container').siblings('.quick-add__submit').find('.comp').removeClass('hidden');
        $(this).parents('.card_product_variant_container').siblings('.quick-add__submit').find('.comp').text(com_price);
      }else{
        $(this).parents('.card_product_variant_container').siblings('.quick-add__submit').find('.comp').addClass('hidden');
        $(this).parents('.card_product_variant_container').siblings('.quick-add__submit').find('.comp').text('');
      }
      $(this).parents('.card_product_variant_container').siblings('.quick-add__submit').find('.n-price').text(price);
    }
  });
});



$(document).on('click','.tabs_list_item', function(){
    $(this).parents('.tabs_list').find('.tabs_list_item').removeClass('active');
    $(this).parents('.product_content_tabs').find('.tabs-inner').removeClass('active');
    var get_id = $(this).data('id');
    $(this).addClass('active');
    $('#'+get_id).addClass('active');
});

$('.product-form__input input[type=radio]').change(function() {
  $(this).siblings('legend').find('.selected_val').text($(this).val());
  var variant_arr = [];
  $('.product-form__input').each(function(){
    var selected_val = $(this).find('input[type=radio]:checked').val();
    if(selected_val){
      variant_arr.push(selected_val);
    }
  });
  var var_title = variant_arr.join(' / ');
  $('#hidden_select option').each(function(){
    var hidden_val = $(this).attr('var-title');
    if(hidden_val == var_title) {
      if($(this).data('qty') > 0) {
        var varaint_price = $(this).data('price');
        setTimeout(function () {
          $('.product-form__submit span').html('Add to cart | <span>'+varaint_price+'</span>');
          $('#sticky_atc_btn').html('Add to cart | <span>'+varaint_price+'</span>');
        }, 1100);
      }
    }
  });
});

$(document).ready(function(){
  if($(window).width() < 768 && document.body.classList.contains('template-product')) {
    $(window).on('scroll', function(){
      if($(window).scrollTop() > $('.product-form__submit').offset().top){
        $('#sticky_atc_btn').addClass('active');
      } else {
        $('#sticky_atc_btn').removeClass('active');
      }
    });
  }
});

$('.footer-block--menu h2.footer-block__heading').click(function(){
  $(this).toggleClass('active_accordian');
  $('.footer_menu_list').slideToggle();
  if($(this).hasClass('active_accordian')) {
    $(this).find('span').text('-');
  }else{
    $(this).find('span').text('+');
  }
});

$('#sticky_atc_btn').click(function(){
  $('product-info .product-form__submit').trigger('click');
});